export class NewResponseBody<T> {
    title: string;
    message: string;
    data: T;

    constructor(data: Partial<NewResponseBody<T>>) {
        Object.assign(this, data);
    }
}
